/* eslint-disable no-console */
import mixpanel from 'mixpanel-browser';

let isMixpanelInitialized = false;

/**
 * Fetch Mixpanel configuration served under the spaces origin.
 * @returns {Promise<{token: string, proxyHost: string}|undefined>}
 */
export async function fetchMixpanelConfig() {
  try {
    const response = await fetch('/spaces/mixpanel-api.json');
    const data = await response.json();
    if (data && data.MIXPANEL_TOKEN) {
      return { token: data.MIXPANEL_TOKEN, proxyHost: data.MIXPANEL_PROXY_HOST };
    }
  } catch (e) {
    console.error('Failed to fetch Mixpanel config', e);
  }
  return undefined;
}

/**
 * Initialize the Mixpanel SDK. Persistence is forced to localStorage
 * (SysAid clients must not use cookies). Safe to call multiple times.
 * @param {{token: string, proxyHost: string}} config
 */
export function initializeMixpanel(config) {
  if (!config || !config.token) {
    console.warn('Mixpanel: No valid token found in mixpanel-api.json');
    return;
  }
  if (!config.proxyHost) {
    console.warn('Mixpanel: No valid proxy host found in mixpanel-api.json');
    return;
  }
  if (isMixpanelInitialized) {
    return;
  }
  try {
    mixpanel.init(config.token, {
      debug: process.env.NODE_ENV !== 'production',
      track_pageview: false,
      api_host: config.proxyHost,
      persistence: 'localStorage',
      persistence_name: 'ssp'
    });
    isMixpanelInitialized = true;
  } catch (error) {
    console.error('Failed to initialize Mixpanel:', error);
    isMixpanelInitialized = false;
  }
}

export function isMixpanelReady() {
  return isMixpanelInitialized;
}

/**
 * Identify the current user and set identity super properties.
 * @param {string} globalUserId
 * @param {string} accountId
 * @param {Object} [properties] extra people-profile properties
 */
export function identifyMixpanelUser(globalUserId, accountId, properties) {
  if (!isMixpanelInitialized) {
    console.warn('Mixpanel: Cannot identify user - Mixpanel not initialized');
    return;
  }
  try {
    mixpanel.identify(globalUserId);
    mixpanel.people.set({
      $account_id: accountId,
      $user_id: globalUserId,
      ...properties
    });
    mixpanel.register({ account_id: accountId, user_id: globalUserId });
  } catch (error) {
    console.error('Failed to identify user in Mixpanel:', error);
  }
}

/** Reset identity (call on logout). */
export function resetMixpanelUser() {
  if (!isMixpanelInitialized) {
    return;
  }
  try {
    mixpanel.reset();
  } catch (error) {
    console.error('Failed to reset Mixpanel user:', error);
  }
}



// WEBPACK FOOTER //
// ./utils/setupMixpanel.js